import { Builder, withChildren } from '@builder.io/react';

import Section from '../../elements/section/index';

const SectionWithBuilderChildren = withChildren(Section);

Builder.registerComponent(SectionWithBuilderChildren, {
  name: 'SectionGallery',
  inputs: [
    {
      name: 'id',
      type: 'string'
    },
    {
      name: 'container',
      type: 'boolean'
    },
    {
      name: 'bg',
      type: 'string',
      defaultValue: 'bg-transparent',
      enum: [
        'bg-transparent',
        'bg-neutral-950',
        'bg-neutral-900',
        'bg-neutral-100',
        'bg-neutral-800'
      ]
    },
    {
      name: 'relative',
      type: 'boolean'
    },
    {
      name: 'paddingTop',
      type: 'boolean'
    },
    {
      name: 'paddingBottom',
      type: 'boolean'
    },
    {
      name: 'overflowHidden',
      type: 'boolean'
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'SectionTitle',
        options: {
          overtitle: 'Duis Mollis',
          title: 'Sed posuere consectetur estat lobortis posuere',
          subtitle:
            'Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.Sed posuere consectetur est at lobortis. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio.'
        }
      }
    },
    {
      component: {
        name: 'Gallery',
        options: {
          gradientColor: '#101010',
          tabItems: [
            {
              label: 'Insurance',
              bullets: [
                {
                  text: 'AI-powered claim & customer segmentation: Utilize machine learning techniques to surface nonobvious segments and resolve claims at scale.'
                },
                {
                  text: 'Optimal claim routing: Design optimal routing solutions to resolve claims quickly, at the optimal value. '
                },
                {
                  text: 'Adjusted risk modeling: Identify variables most predictive of risk to simplify approvals and drive optimal pricing. '
                }
              ],
              image: {
                src: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F911661720e5948eaafda9c13d3fb7a58',
                width: 799,
                height: 473,
                alt: 'Insurance workflow'
              }
            },
            {
              label: 'Logistics & Transportation',
              bullets: [
                {
                  text: 'ETA modeling: Accurately predict shipment arrivals across your network to optimize fleet management and production planning.'
                },
                {
                  text: 'Real-time fleet management: Monitor and track your logistics network with executive view and operator-level controls.'
                }
              ],
              image: {
                src: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2Fbc04f71bee1049fab8c3a13777a1c3e8',
                width: 799,
                height: 473,
                alt: 'Logistics dashboard'
              }
            }
          ]
        }
      }
    }
  ]
});
